import React, { useContext, useRef, useState } from 'react'
import {
    generateBodyPitch,
    headBody5,
    headBody6,
    headBody7,
    headBody8,
    headBody9,
} from '@/config/mesh_map'
import FUIcon from '../../../Common/FUIcon'
import { AvatarContext } from '@/components/RenderComp/Avatar'
import { RESOURCE_MANAGER } from '@/config'

const BodyBundle = (props) => {
    const {
        item,
        bodyData,
        dispatchTableData,
        selectedDressupPart,
        setSelectedDressupPart,
        setSelectedDressupType,
        selectedTypeInCurrentPart,
        setSelectedTypeInCurrentPart,
        bodyPitchs,
        setBodyPitchs,
    } = props
    const { avatar } = useContext(AvatarContext)
    const headBodyDataRef = useRef({
        headBody5,
        headBody6,
        headBody7,
        headBody8,
        headBody9,
    })
    function handlezConfSelect(index) {
        const confData = headBodyDataRef.current[`headBody${index}`]
        const oldIndex = selectedTypeInCurrentPart.selected
        const oldConfData = headBodyDataRef.current[`headBody${oldIndex}`]

        confDataHandler({
            type: selectedDressupPart,
            name: selectedTypeInCurrentPart.name,
            value: [confData, index]
        })
        RESOURCE_MANAGER.recorder.record({
            type: 'body',
            oldValue: {
                type: selectedDressupPart,
                name: selectedTypeInCurrentPart.name,
                value: [oldConfData, oldIndex]
            },
            newValue: {
                type: selectedDressupPart,
                name: selectedTypeInCurrentPart.name,
                value: [confData, index]
            },
            handler: confDataHandler
        })
    }

    function confDataHandler({ type, name, value: [confData, index] }) {
        if (!avatar) return
        const bone_controllers = confData.bone_controllers
        if (bone_controllers && bone_controllers.length) {
            for (let item of bone_controllers) {
                const key = item.name.slice(0, -3);
                bodyPitchs[key] = item.value * (item.name.endsWith('Pos') ? 50 : -50)
                setBodyPitchs(bodyPitchs)
                avatar.setBoneTransform(item.name, item.value)
            }
        }
        setSelectedDressupPart(type)
        setSelectedDressupType(name)
        selectedTypeInCurrentPart.selected = index
        setSelectedTypeInCurrentPart(selectedTypeInCurrentPart)
        dispatchTableData({
            type: 'body',
            data: {
                name,
                selected: index
            }
        })
    }

    return (
        <div className='body-bundle' style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
            <div
                className={'component component-body-bundle ' + (item.index === bodyData?.types[0].selected ? 'active' : '')}
            >
                <FUIcon
                    key={item.icon_url}
                    name={item.icon_url}
                    onClick={() => handlezConfSelect(item.index)}
                />
            </div>
            <span className='component-label'>
                {item.name}
            </span>
        </div>
    )
}

export default BodyBundle
